import { useMemo } from 'react';

/**
 * Custom hook for service slot filter configuration
 * @returns {Array} Filter configuration for AdvancedTable
 */
export const useServiceSlotFilters = () => {
    return useMemo(() => [
        {
            id: 'status',
            label: 'Booking Status',
            type: 'select',
            options: [
                { value: 'Upcoming', label: 'Upcoming' },
                { value: 'Completed', label: 'Completed' },
                { value: 'Cancelled', label: 'Cancelled' },
            ],
            multiple: false,
            searchable: false,
        },
        {
            id: 'customerName',
            label: 'Customer Name',
            type: 'text',
            placeholder: 'Search by customer name...',
        },
        {
            id: 'phoneNo',
            label: 'Phone Number',
            type: 'text',
            placeholder: 'Search by phone number...',
        },
        {
            id: 'registrationNo',
            label: 'Registration Number',
            type: 'text',
            placeholder: 'Search by registration number...',
        },
        {
            id: 'serviceName',
            label: 'Service Name',
            type: 'text',
            placeholder: 'Search by service name...',
        },
        {
            id: 'date',
            label: 'Date',
            type: 'date',
        },
    ], []);
};
